
// Helper function to convert database bank details to template format
export const convertBankDetails = (bankDetails: any) => {
  if (!bankDetails) return {};
  
  return {
    accountName: bankDetails.account_name,
    accountNumber: bankDetails.account_number,
    sortCode: bankDetails.sort_code,
    bankName: bankDetails.bank_name,
    iban: bankDetails.iban,
    swift: bankDetails.swift
  };
};

// Helper function to get review link URL from platform key
export const getReviewLinkUrl = (platform: string, businessProfile: any) => {
  if (!platform || !businessProfile?.review_links) return undefined;
  
  // Parse review_links if it's a string
  let parsedReviewLinks = businessProfile.review_links;
  if (typeof businessProfile.review_links === 'string') {
    try {
      parsedReviewLinks = JSON.parse(businessProfile.review_links);
    } catch (e) {
      console.error("Error parsing review_links:", e);
      return undefined;
    }
  }
  
  console.log("DEBUG: Getting URL for platform:", platform, "from links:", parsedReviewLinks);
  
  // Get the URL based on the platform
  switch (platform) {
    case 'google':
      return parsedReviewLinks.google;
    case 'facebook':
      return parsedReviewLinks.facebook;
    case 'sprintmint':
      return parsedReviewLinks.sprintmint;
    case 'custom':
      return parsedReviewLinks.custom?.url;
    default:
      return undefined;
  }
};
